<template>
  <el-dialog
    class="m-feedback-dialog"
    :visible.sync="showMFeedback"
    width="88%">
    <div class="m-feedback-dialog-content">
      <img class="feedback-close" @click="showMFeedback = false" src="../assets/v3/team/close-dialog.png" alt="close">
        <div class="feedback-dialog-title">Umpan balik</div>
        <el-form label-position="top" :model="feedbackForm" :rules="rules" ref="feedbackForm" label-width="200px" class="m-fedback-form">
          <el-form-item label="Nama" prop="name">
          <el-input v-model="feedbackForm.name"></el-input>
        </el-form-item>
        <el-form-item label="Nomor telepon" prop="phone">
          <el-input v-model="feedbackForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="Konten umpan balik" prop="content">
          <el-input
            type="textarea"
            placeholder=""
            v-model="feedbackForm.content"
            maxlength="160"
            :rows="4"
            show-word-limit
          />
        </el-form-item>
        <el-form-item>
          <el-button class="send-btn" type="success" :loading="isLoadingBtn" @click="submitForm('feedbackForm')">Mengirim</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showMFeedback: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  data(){
    return{
      feedbackForm: {
        name:'',
        phone: '',
        content: ''
      },
      rules: {
        name: [
          { required: true, message: 'Harap diisi', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: 'Harap diisi', trigger: 'blur' },
        ],
        content: [
          { required: true, message: 'Harap diisi', trigger: 'blur' },
        ]
      },
      isLoadingBtn: false
    }
  },
  methods:{
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoadingBtn = true
          setTimeout(() => {
            this.$message({
              message: 'Keberhasilan umpan balik',
              type: 'success',
              offset: 160
            })
            this.isLoadingBtn = false
            this.$refs.feedbackForm.resetFields()
            this.showPcFeedback = false
          },1000)
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.m-feedback-dialog-content{
  background: #C6E8ED;
  border-radius: 8px;
  position: relative;
  padding: 27px 25px 6px 25px;
  box-sizing: border-box;
  font-weight: 600;
  .feedback-dialog-title{
    font-size: 20px;
    color: #145246;
    margin-bottom: 14px;
  }
  .feedback-close{
    width: 24px;
    height: 24px;
    position: absolute;
    right: 13px;
    top: -30px;
    cursor: pointer;
  }

  .send-btn{
    width: 100%;
    background: #145246;
    border-radius: 24px;
    height: 48px;
    border: none !important;
  }
}
</style>